import { toast } from 'sonner';
import { buildAdPayUrl } from '../components/MyAdsTab';

export const MY_ADS_URL = '/dashboard?tab=myads';

/** Shared post-submit handling for the 3 ad forms (create + edit). */
export function handleAdSaved(resData, { navigate, isAr, title }) {
  if (resData?.payment_required && resData?.payment) {
    toast.success(resData.message || (isAr ? 'تم حفظ الإعلان — أكمل الدفع لتفعيله' : 'Ad saved — complete payment to activate'));
    navigate(buildAdPayUrl({ id: resData.ad_id, title, payment: resData.payment }, isAr));
    return;
  }
  toast.success(resData?.message || (isAr ? 'تم حفظ الإعلان بنجاح' : 'Ad saved successfully'));
  navigate(MY_ADS_URL);
}

export function adErrorMessage(err, isAr) {
  const d = err?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (d?.message) return d.message;
  return isAr ? 'فشل في حفظ الإعلان' : 'Failed to save ad';
}
